import React from 'react';
import AppHeader from './AppHeader';
import {Route, Switch, useHistory} from 'react-router-dom';
import ManageArticleListPage from '../../pages/manage/articleList';
import './ManagerLayout.less';
import ManageRouter from '../../pages/manageRouter';
import useAuth from '../../utils/AuthContext';

export default function ManageLayout() {
  const history = useHistory();
  const auth = useAuth();
  return (
    <div>
      <div className={'ManageHeader'}>
        <div className={'ManageNavBar'}>
          <div className={'AppNavItem'} onClick={() => history.push('/manage/article')}>
            文章管理
          </div>
          <div className={'AppNavItem'} onClick={() => history.push('/manage/user')}>
            会员管理
          </div>
          {auth.currentUser?.isSu && (
            <>
              <div className={'AppNavItem'} onClick={() => history.push('/manage/payment')}>
                支付订单
              </div>
              <div className={'AppNavItem'} onClick={() => history.push('/manage/manager')}>
                专委会账号管理
              </div>
              <div className={'AppNavItem'} onClick={() => history.push('/manage/doubleMember')}>
                双选会员同步
              </div>
              <div className={'AppNavItem'} onClick={() => history.push('/manage/congress')}>
                会员代表大会
              </div>
              <div className={'AppNavItem'} onClick={() => history.push('/manage/system')}>
                系统配置
              </div>
            </>
          )}
          <div className={'AppNavItem'} onClick={() => history.push('/')}>
            返回首页
          </div>
        </div>
      </div>
      <div className={'ManageBody'}>
        <ManageRouter />
      </div>
    </div>
  );
}
